import PropTypes from 'prop-types';

const privatePackageTrackerModel = () => {
  PropTypes.shape({
    packageInfo: {
      companyName: PropTypes.string,
      packageId: PropTypes.number
    },
    recipientInfo: {
      firstName: PropTypes.string,
      originalPhone: PropTypes.string
    },
    redispatchInfo: {
      trackingCode: PropTypes.string,
      maxPickupTime: PropTypes.number,
      redispatchAgency: PropTypes.shape({
        name: PropTypes.string,
        firstLine: PropTypes.string,
        secondLine: PropTypes.string
      })
    },
    destinationInfo: {
      firstLine: PropTypes.string,
      secondLine: PropTypes.string,
      complement: PropTypes.string,
      coordinates: {
        lat: PropTypes.string,
        lng: PropTypes.string
      },
      confirmedByRecipient: PropTypes.bool
    },
    eta: PropTypes.number,
    currentStatus: {
      error: PropTypes.number,
      inProgress: PropTypes.bool,
      destination: PropTypes.string,
      type: PropTypes.string
    },
    shipperStatus: {
      code: PropTypes.number,
      label: PropTypes.string,
      description: PropTypes.string,
      actionRequired: {
        reasonLabel: PropTypes.string,
        reasonDescription: PropTypes.string
      }
    },
    permissions: PropTypes.arrayOf(PropTypes.string),
    relativeEta: PropTypes.number,
    driverInfo: PropTypes.shape({
      fullName: PropTypes.string,
      photoUrl: PropTypes.string
    }),
    currentDriverPosition: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }),
    shouldConfirmPackageDelivery: PropTypes.bool,
    receivedBy: PropTypes.string
  });
};

export default privatePackageTrackerModel;
